import React from 'react'
import PropTypes from 'prop-types'

const InfoIcon = (props) => {
  const {
    color = '#FFFFFF',
    width = '20',
    height = '21',
    className = '',
  } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 15.7754H11V9.77539H9V15.7754ZM10 7.77539C10.2833 7.77539 10.5208 7.67956 10.7125 7.48789C10.9042 7.29622 11 7.05872 11 6.77539C11 6.49206 10.9042 6.25456 10.7125 6.06289C10.5208 5.87122 10.2833 5.77539 10 5.77539C9.71667 5.77539 9.47917 5.87122 9.2875 6.06289C9.09583 6.25456 9 6.49206 9 6.77539C9 7.05872 9.09583 7.29622 9.2875 7.48789C9.47917 7.67956 9.71667 7.77539 10 7.77539ZM10 20.7754C8.61667 20.7754 7.31667 20.5129 6.1 19.9879C4.88333 19.4629 3.825 18.7504 2.925 17.8504C2.025 16.9504 1.3125 15.8921 0.7875 14.6754C0.2625 13.4587 0 12.1587 0 10.7754C0 9.39206 0.2625 8.09206 0.7875 6.87539C1.3125 5.65872 2.025 4.60039 2.925 3.70039C3.825 2.80039 4.88333 2.08789 6.1 1.56289C7.31667 1.03789 8.61667 0.775391 10 0.775391C11.3833 0.775391 12.6833 1.03789 13.9 1.56289C15.1167 2.08789 16.175 2.80039 17.075 3.70039C17.975 4.60039 18.6875 5.65872 19.2125 6.87539C19.7375 8.09206 20 9.39206 20 10.7754C20 12.1587 19.7375 13.4587 19.2125 14.6754C18.6875 15.8921 17.975 16.9504 17.075 17.8504C16.175 18.7504 15.1167 19.4629 13.9 19.9879C12.6833 20.5129 11.3833 20.7754 10 20.7754ZM10 18.7754C12.2333 18.7754 14.125 18.0004 15.675 16.4504C17.225 14.9004 18 13.0087 18 10.7754C18 8.54206 17.225 6.65039 15.675 5.10039C14.125 3.55039 12.2333 2.77539 10 2.77539C7.76667 2.77539 5.875 3.55039 4.325 5.10039C2.775 6.65039 2 8.54206 2 10.7754C2 13.0087 2.775 14.9004 4.325 16.4504C5.875 18.0004 7.76667 18.7754 10 18.7754Z"
        fill={color}
      />
    </svg>
  )
}

InfoIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(InfoIcon)
